import React from 'react';

const Loader = ({ className = 'h-32 w-32' }) => {
  return (
    <div className="flex items-center justify-center w-full h-full">
      <video autoPlay loop muted playsInline className={`object-contain ${className}`}>
        <source src="/Icon.webm" type="video/webm" />
        Your browser does not support the video tag.
      </video>
    </div>
  );
};

export default Loader;
